import { CommonModule, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import {
  Client,
  EventDataChannel,
  GuidDictionaryItem,
} from '../../../../../../../api/api-reference';
import { FilterPanelComponent } from '../../filter-panel.component';

export interface EventsFilterOutput {
  selectedAssetTypes: string[];
  selectedEventChannels: string[];
}

@Component({
  selector: 'app-events-filter',
  standalone: true,
  imports: [CommonModule, NgFor, TranslateModule, FilterPanelComponent],
  templateUrl: './events-filter.component.html',
  styleUrl: './events-filter.component.scss',
})
export class EventsFilterComponent implements OnInit {
  @Input() numberOfResults: number = 0;
  @Input() selectedAssetTypes: string[] = [];
  @Input() selectedEventChannels: string[] = [];

  @Output() applied = new EventEmitter<EventsFilterOutput>();

  assetTypes: GuidDictionaryItem[] = [];

  readonly eventChannels = Object.values(EventDataChannel).slice(1);

  draftAssetTypes: string[] = [];
  draftEventChannels: string[] = [];

  get activeFilterCount(): number {
    return this.selectedAssetTypes.length + this.selectedEventChannels.length;
  }

  constructor(private client: Client, private toastr: ToastrService) {}

  ngOnInit(): void {
    this.reset();
    this.client.getAllAssetTypesForOptions(undefined).subscribe({
      next: (res) => (this.assetTypes = res ?? []),
      error: (err) => this.toastr.error(err),
    });
  }

  isIn<T>(list: T[], item: T): boolean {
    return list.includes(item);
  }

  toggle<T>(list: T[], item: T): T[] {
    return list.includes(item) ? list.filter((i) => i !== item) : [...list, item];
  }

  toggleGuid(list: string[], item: GuidDictionaryItem): string[] {
    const val = item.value!;
    return list.includes(val) ? list.filter((v) => v !== val) : [...list, val];
  }

  onApply(): void {
    this.applied.emit({
      selectedAssetTypes: this.draftAssetTypes,
      selectedEventChannels: this.draftEventChannels,
    });
  }

  onCancel(): void {
    this.reset();
  }

  private reset(): void {
    this.draftAssetTypes = [...this.selectedAssetTypes];
    this.draftEventChannels = [...this.selectedEventChannels];
  }
}
